import { useSafariPackagesContext } from "provider/SharePackagesProvider";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const MainHeader = () => {
  const { packageViewData, packageViewLoading } = useSafariPackagesContext();
  return (
    <section className="banner_section-inner packagebnner position-relative">
      <picture className="position-relative">
        <source
          srcSet={"/img/baneer1719164625.jpg"}
          media="(max-width:576px)"
          type="image/jpg"
        />
        <img
          src="/img/baneer1719164625.jpg"
          className="d-block w-100 banner_search"
          alt="banner"
          type="image/jpg"
          loading="lazy"
        />
      </picture>
      <div className="banner_searchBox">
        <Container>
          <Row>
            <Col md={12}>
              <div className="headingBnner_inner">
                {packageViewLoading ? (
                  <>
                    
                  </>
                ) : (
                  <>
                    <h1>{packageViewData?.package_display_name || "Safari Adventure Awaits"}</h1>
                    <p className="mb-0">
                      Organized by{" "}
                      <Link to={`/operator/${packageViewData?.partner?.slug}/profile`}>
                        <strong>{packageViewData?.partner?.business_name || ""}</strong>
                      </Link>
                    </p>
                  </>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};

export default MainHeader;
